import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/TravelSolution/TravelSolution.css";
import "../OURM.I.C.E.Solutions/OURM.I.C.E.Solution.css";
import Heading from "../../../utls/Heading";
const OurMIICESolution = () => {
  const solutionsData = [
    {
      title: "Meetings",
      description: "We organize professional business meetings in top locations with the latest technology and seamless coordination.",
      checklistItems: [
        "Venue selection & setup",
        "Audio-visual & IT support",
        "Travel & accommodation arrangements"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Travel%20C.png",
      sectionClass: "first-section"
    },
    {
      title: "Incentives",
      description: "Motivate and reward your teams with exclusive, tailor-made incentive programs designed to boost productivity.",
      checklistItems: [
        "Venue selection & setup",
        "Audio-visual & IT support",
        "Travel & accommodation arrangements"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20T.png",
      sectionClass: "second-section"
    },
    {
      title: "Conferences",
      description: "Flawless conference management, ensuring smooth registration, speaker coordination, and premium event execution.",
      checklistItems: [
        "Venue selection & setup",
        "Audio-visual & IT support",
        "Travel & accommodation arrangements"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Corporate%20M.png",
      sectionClass: "third-section"
    },
    {
      title: "Exhibitions & Events",
      description: "We bring your vision to life with top-notch event planning, venue sourcing, and exhibitor management.",
      checklistItems: [
        "Venue selection & setup",
        "Audio-visual & IT support",
        "Travel & accommodation arrangements"
      ],
      image: "https://blueberrywebsites.azureedge.net/bbt/images/Procurement.png",
      sectionClass: "fourth-section"
    }
  ];

  return (
    <>
      <div className="container travel-solutions-section mt-5 pt-md-4 mb-5">
        <div className="row">
          <div className="col-md-12 mt-5">
            <Heading className="text-center customheadings">
              <span>Our </span> M.I.C.E. Solutions
            </Heading>
          </div>
          
          {solutionsData.map((solution, index) => (
            <div key={index} className="row ps-3">
              <div className="col-md-8  mt-3 paddingL">
                <h3 className={`${solution.sectionClass} headings`}>{solution.title}</h3>
                <div
                  className="bgimage"
                  style={{
                    "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                  }}
                >
                  <p className="mt-4 fs5">{solution.description}</p>
                  {solution.checklistItems.map((item, itemIndex) => (
                    <div key={itemIndex} className="d-flex align-items-center">
                      <LazyLoadImage
            effect="blur"

                        src="https://blueberrywebsites.azureedge.net/bbt/icons/TourismIcons/CheckBox.png"
                        alt="checkbox"
                        className="checkbox me-3"
                      />
                      <p className="mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-4 right-side d-none d-md-block">
                <div className="d-flex justify-content-center mt-2">
                  <LazyLoadImage
            effect="blur"

                    src={solution.image}
                    alt={solution.title}
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default OurMIICESolution;